import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import Clipboard from 'react-clipboard.js';
import shortid from 'shortid';
import { Tooltip } from '@usealloy/component-library';

import { handleClipboardCopy } from '~/helpers/messages';

const CopyToClipboardPropTypes = {
  data: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.object,
    PropTypes.string,
  ]).isRequired,
  category: PropTypes.string.isRequired,
  onCopy: PropTypes.func,
};

const renderDataSafely = data => {
  if (Array.isArray(data) && data.length > 0) {
    return data.filter(element => typeof element.props?.children !== 'object');
  }
  return data;
};

const CopyToClipboard = ({
  data,
  category,
  onCopy,
}) => {
  const id = useRef(`_${shortid.generate()}`);
  let formattedData = data;
  if (Array.isArray(data)) {
    if (!data.length) return null;
    if (category.includes('address') && category !== 'ip_address') {
      formattedData = data.map(d => d.key).join(' ').replace(/[,()-]/g, '');
    } else {
      formattedData = data.map(d => {
        // don't include objects in the formatted data
        // since they get rendered as [object Object]
        if (typeof d.props?.children === 'object') return '';
        return d.props.children;
      }).join(' ').replace(/[,()-]/g, '').trim();
    }
  }

  return (
    <span className="flex start copy-clipboard no-wrap">
      <span className="flex-col">
        {renderDataSafely(data)}
      </span>
      <span>
        <Tooltip content="Copy to Clipboard" style={{ fontSize: 'var(--cl-font-size-1)' }}>
          <span>
            <Clipboard
              component="i"
              button-id={id.current}
              button-className="far fa-fw fa-clone"
              data-clipboard-text={formattedData}
              onSuccess={(...args) => {
                if (onCopy) {
                  onCopy(...args);
                } else {
                  handleClipboardCopy(...args);
                }
              }}
            />
          </span>
        </Tooltip>
      </span>
    </span>
  );
};

CopyToClipboard.propTypes = CopyToClipboardPropTypes;

export default CopyToClipboard;
